import { Link } from "react-router-dom";

const friendLinks = ["光影影视网", "环球剧集社", "影迷俱乐部", "光影档案馆"];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-primary-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
                <i className="ri-clapperboard-fill text-primary-950 text-xl" />
              </span>
              <span className="text-lg font-bold text-background-50">麻豆网站</span>
            </div>
            <p className="text-sm text-primary-200 leading-relaxed">
              麻豆网站提供丰富的影视资源，涵盖电影、电视剧及热门影视资讯，实时更新最新影视动态，为影迷打造一站式的影视信息平台。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">内容导航</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/category/movie" className="text-primary-200 hover:text-accent-400 transition-colors">最新电影</Link></li>
              <li><Link to="/category/tv" className="text-primary-200 hover:text-accent-400 transition-colors">热门电视剧</Link></li>
              <li><Link to="/category/news" className="text-primary-200 hover:text-accent-400 transition-colors">影视资讯</Link></li>
              <li><Link to="/search" className="text-primary-200 hover:text-accent-400 transition-colors">全站搜索</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">友情链接</h3>
            <ul className="space-y-2.5 text-sm">
              {friendLinks.map((link) => (
                <li key={link}>
                  <span className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">{link}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">联系我们</h3>
            <ul className="space-y-3 text-sm text-primary-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400 text-base" />
                contact@madou-example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-accent-400 text-base" />
                微信公众号：麻豆影视
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400 text-base" />
                内容每日更新
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300">
          <p>© 2026 麻豆网站 · 本站内容均为信息展示，不提供任何影片播放与下载服务</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="hover:text-accent-400 transition-colors">隐私政策</Link>
            <Link to="/about" className="hover:text-accent-400 transition-colors">用户协议</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}